import React from 'react';
import logo from '../images/logo-endless.svg';

export default function Nav() {
    return (
        <nav>
            {/* <img src={logo} alt="logo"/> */}
            <h2>A la luxe</h2>
        </nav>
    )
}
